import MDatePicker from "@/assets/plugins/mps-vuetify-compat/pickers/MDatePicker";

export default {
    install(Vue, options) {
        const components = {MDatePicker};
        Object.keys(components).forEach(key => Vue.component(key, components[key]));
    }
}
